import * as React from 'react';
import {useState, useEffect} from "react";
import {DataGrid, GridToolbarExport} from '@mui/x-data-grid';
import {TextField, Button, Box, Typography, Grid} from '@mui/material';
import {useNavigate} from 'react-router-dom'
import axios from "axios";
import {logout, getLocalToken} from '../utils';


const columns = [
    {field: 'last_name', headerName: 'Nachname', sortable: false, flex: 0.2},
    {field: 'first_name', headerName: 'Vorname', sortable: false, flex: 0.2},
    {field: 'family_count', headerName: 'Familienmitglieder', sortable: false, flex: 0.1},
    {field: 'email', headerName: 'Email', sortable: false, flex: 0.3},
    {field: 'phone_number', headerName: 'Telefon', sortable: false, flex: 0.3},
    {field: 'social_number', headerName: 'Sozialversicherungsnummer', sortable: false, flex: 0.3},
    {field: 'created', headerName: 'Erstellt', sortable: false, flex: 0.3, hide: true}
];

export default function Users() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [pageSize, setPageSize] = useState(100);
    const [searchPhrase, setSearchPhrase] = useState('');
    const [debouncedSearch, setDebouncedSearch] = useState('');
    const [currTblPage, setCurrTblPage] = useState(0);
    const [searchText, setSearchText] = useState('');
    const [rows, setRows] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const token = getLocalToken();

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(searchPhrase);
            setCurrTblPage(0); //reset to first page when typing a new search
        }, 300);
        return () => clearTimeout(handler);
    }, [searchPhrase]);

    useEffect(() => {
        const offset = currTblPage * pageSize;
        const limit = pageSize;
        let query = `?offset=${offset}&limit=${limit}`;
        if (debouncedSearch) query += `&search=${encodeURIComponent(debouncedSearch)}`;
        setLoading(true);
        axios.get(`/admin/api/v1/users${query}`, {headers: {"Authorization": `Bearer ${token}`}})
            .then((res) => {
                if (res && res.status === 200) {
                    if (res.data.payload) {
                        setRows(res.data.payload.items);
                        setTotalRows(Number(res.data.payload.items[0].total_count));
                        setLoading(false);
                    }
                }
            })
            .catch((err) => {
                setLoading(false);
                console.log(err);
                if (err.response && err.response.status === 401) {
                    logout();
                }
            });
    }, [currTblPage, pageSize, token, debouncedSearch]);

    return (
        <React.Fragment>
            <Box mb={2}>
                <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    justifyContent="space-between"
                >
                    <Grid
                        item
                        xs={12}
                        md
                        container
                        spacing={2}
                        alignItems="center"
                        justifyContent="flex-start"
                    >
                        <Grid item xs={12} sm={6} md="auto">
                            <TextField
                                label="Suchen..."
                                variant="standard"
                                size="small"
                                fullWidth
                                value={searchPhrase}
                                onChange={(e) => setSearchPhrase(e.target.value)}
                                sx={{ minWidth: 200 }}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
            <DataGrid
                autoHeight={true}
                style={{border: '0', minWidth: 100}}
                getEstimatedRowHeight={() => 100}
                getRowHeight={() => 'auto'}
                disableColumnMenu
                pageSize={pageSize}
                initialState={{
                    pagination: {paginationModel: {pageSize: 100}},
                }}
                pageSizeOptions={[25, 50, 100]}
                paginationMode="server"
                rowCount={totalRows}
                pagination
                rows={rows}
                columns={columns}
                disableSelectionOnClick
                loading={loading}
                onPaginationModelChange={(val) => {
                    setPageSize(val.pageSize);
                    setCurrTblPage(val.page)
                }}
                sx={{
                    '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': {
                        py: 1,
                    },
                    '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': {
                        py: '15px',
                    },
                    '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': {
                        py: '22px',
                    },
                }}
                onRowClick={(params) => {
                    navigate(`/users/${params.row.id}/edit`, {state: params.row});
                }}
                onSelectionModelChange={(ids) => {
                    const selectedIDs = new Set(ids);
                    const selectedRowData = rows.filter((row) =>
                        selectedIDs.has(row.id.toString())
                    );

                }}
            />
        </React.Fragment>
    );
}